import React, { useState, useEffect } from 'react'
import { fetchRequest } from '@utils/fetch.js'

const SubscribeForm = ({
  className = '',
  title = 'Subscribe to DockyLab',
  subtitle = 'Be the first to know about new collections and exclusive offers.',
  placeholder = 'Enter your email address',
  buttonText = 'Subscribe Now',
  termsText = (
    <span>
      By signing up, you agree to DockyLab's{' '}
      <a href="#" className="underline">
        Terms of Use
      </a>{' '}
      and{' '}
      <a href="#" className="underline">
        Privacy Policy
      </a>
      .
    </span>
  ),
  newsText = 'Send me news and special offers. I can unsubscribe at any time.',
  defaultChecked = true,
}) => {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('')
  const [timer, setTimer] = useState(0)
  const [checked, setChecked] = useState(defaultChecked)

  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000)
      return () => clearTimeout(countdown)
    }
  }, [timer])

  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)

  const onSubscribe = async () => {
    if (!validateEmail(email)) {
      setStatus('Please enter a valid email address.')
      return
    }
    if (!checked) {
      setStatus('Please agree to the terms to subscribe.')
      return
    }
    try {
      const res = await fetchRequest(
        `${process.env.GATSBY_WORKER_DOMAIN}/auth/subscribe`,
        {
          method: 'POST',
          body: { email },
        },
      )
      if (res.status === 200) {
        setStatus('Subscription successful, thank you!')
        setEmail('')
      } else {
        setStatus(res.msg || 'Subscription failed, please try again later.')
      }
    } catch (error) {
      setStatus('Network error, please try again later.')
    }
  }

  return (
    <div id="subscribe" className={`!max-w-6xl mx-auto ${className}`}>
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-black leading-tight mb-4 text-gray-100">
          {title}
        </h2>
        <p className="text-base md:text-lg font-medium text-gray-200 max-w-3xl mx-auto">
          {subtitle}
        </p>
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="flex flex-col sm:flex-row gap-4 mb-6">
          <input
            type="email"
            placeholder={placeholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 px-4 py-3 text-base border-2 border-gray-200 rounded-sm focus:border-blue-500 focus:outline-none transition-colors duration-200 text-gray-900 placeholder-gray-400 bg-white"
          />
          <button
            onClick={onSubscribe}
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-base font-bold rounded-sm hover:from-blue-700 hover:to-blue-800 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            {buttonText}
          </button>
        </div>

        {status && (
          <div
            className={`text-center p-4 rounded-lg ${
              status.includes('successful')
                ? 'bg-green-50 text-green-700 border border-green-200'
                : 'bg-red-50 text-red-700 border border-red-200'
            }`}
          >
            {status}
          </div>
        )}

        {/* <div className="text-center text-xs md:text-sm text-gray-500 mt-6">
          <p>Join thousands of early adopters who trust DockyLab</p>
        </div> */}
      </div>
    </div>
  )
}

export default SubscribeForm
